import React, {Component} from 'react';

import UpgradePersonalAccountForm from './UpgradePersonalAccountForm';

class UpgradePersonalAccount extends Component {

	constructor(props) {
		super(props);
		this.state = {
			orgType: "FIRST_NET"

		}
	}

	render()	{
		return(
			<div className="row padBoth padTop padBottom">
				<div className = "col-12">
					Your account needs to be upgraded to an Organization Account before you can add users. Please enter Organization/Company details below and click Upgrade.
				</div> 

				<UpgradePersonalAccountForm / >
			</div>
		)
	}

}

export default UpgradePersonalAccount;


// WEBPACK FOOTER //
// ./src/manageOrg/UpgradePersonalAccount.js